import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mb-15 mb-md-30 d-sm-flex align-items-center justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title fw-bold mb-0" }, "Previsão recebimentos")
], -1)
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
    }, " MÊS "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " CONTRATOS MÊS "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " RECEBER MES R$ "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " LUCRO MES R$ "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " QTDE CONTRATOS "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " RECEBER ACUMULADO R$ "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " LUCRO ACUMULADO R$ ")
  ])
], -1)
const _hoisted_7 = { class: "shadow-none lh-1 fw-bold ps-0" }
const _hoisted_8 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_9 = { class: "shadow-none lh-1 fw-medium text-body-tertiary" }
const _hoisted_10 = { class: "shadow-none lh-1 fw-medium text-body-tertiary" }
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_12 = { class: "shadow-none lh-1 fw-medium text-body-tertiary" }
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-body-tertiary" }

import { defineComponent, reactive, watch } from "vue";

  import * as serviceDashboard from "@/services/DashboardInvestidor";
  import {f2dec} from "@/utils/funcoes";

  interface IProps {
    previsao: serviceDashboard.PrevisaoDTO[]
  }

  interface IPrevisao extends serviceDashboard.PrevisaoDTO {
  vlrLucroMes: number,
  vlrLucroAcumulado: number,
 }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    previsao: {}
  },
  setup(__props: any) {

var props = __props;

 var controle = reactive({
    percInvestidor: 11,
    previsao:[] as IPrevisao[]
  });

  watch(() => props.previsao, async (novo: any, antigo: any) => {
    
    console.log("montando2...");

    controle.previsao = novo as IPrevisao[];

    var vlrLucroAcumulado = 0;
    controle.previsao.forEach(a=> {
      a.vlrLucroMes = a.valor * (controle.percInvestidor / 100);
      vlrLucroAcumulado += a.vlrLucroMes;
      a.vlrLucroAcumulado = vlrLucroAcumulado;
    })
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).previsao, (item, idx) => {
              return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                _createElementVNode("th", _hoisted_7, _toDisplayString(item.mes), 1),
                _createElementVNode("td", _hoisted_8, _toDisplayString(item.qtde), 1),
                _createElementVNode("td", _hoisted_9, " R$ " + _toDisplayString(_unref(f2dec)(item.valor)), 1),
                _createElementVNode("td", _hoisted_10, " R$ " + _toDisplayString(_unref(f2dec)(item.vlrLucroMes)), 1),
                _createElementVNode("td", _hoisted_11, _toDisplayString(item.qtdeAcum), 1),
                _createElementVNode("td", _hoisted_12, " R$ " + _toDisplayString(_unref(f2dec)(item.valorAcum)), 1),
                _createElementVNode("td", _hoisted_13, " R$ " + _toDisplayString(_unref(f2dec)(item.vlrLucroAcumulado)), 1)
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}
}

})